import(/* webpackMode: "eager" */ "/vercel/path0/src/app/customer/register/page.js");
